import React, { useMemo, useState } from 'react';
import { Box, LinkButton, OptionKey } from '@common-fe/common-fe';

import { Dependent } from '@/modules/employee/employee.types';
import theme from '@/styles/theme';

import { DeductibleUser } from './hooks/useDependents';
import SpendTrackerUser from './SpendTrackerUser';

const ALLOWED_VISIBLE_USERS = 6;

interface Props {
  employeeUser: DeductibleUser;
  users: Dependent[];
  disabled?: boolean;
  selectedHealthPlanYearId?: OptionKey;
}

const SpendTrackerUsersList: React.FC<Props> = ({
  employeeUser,
  users,
  disabled,
  selectedHealthPlanYearId,
}) => {
  const [showAllUsers, setShowAllUsers] = useState(false);

  const visibleUsers = useMemo(
    () => (showAllUsers ? users : users?.slice(0, ALLOWED_VISIBLE_USERS)),
    [showAllUsers, users]
  );

  return (
    <Box
      direction="column"
      justify="start"
      align="start"
      margin={{ top: 'spacing10' }}
      pad={{ top: 'spacing10' }}
      border={{ side: 'top', color: 'border1', size: '1px' }}
      style={{
        flexWrap: 'wrap',
      }}
    >
      <Box direction="row" wrap>
        {visibleUsers?.map((user, index) => (
          <SpendTrackerUser
            key={user?.dependentId}
            index={index}
            disabled={disabled}
            employeeId={employeeUser?.id}
            fullName={user?.fullName || ''}
            isMe={employeeUser?.id === user?.dependentId}
            id={user?.dependentId || ''}
            relationshipType={user?.relationshipType}
            defaultHealthPlanYearId={selectedHealthPlanYearId}
          />
        ))}
      </Box>
      {users?.length > ALLOWED_VISIBLE_USERS && !showAllUsers && (
        <LinkButton style={{ marginTop: theme.spacings.xs }} onClick={() => setShowAllUsers(true)}>
          Show more ({users?.length - ALLOWED_VISIBLE_USERS})
        </LinkButton>
      )}
    </Box>
  );
};

export default React.memo(SpendTrackerUsersList);
